import { render, staticRenderFns } from "./quarterlyAssessment.vue?vue&type=template&id=3c09cb16&scoped=true&"
import script from "./quarterlyAssessment.vue?vue&type=script&lang=ts&"
export * from "./quarterlyAssessment.vue?vue&type=script&lang=ts&"
import style0 from "./quarterlyAssessment.vue?vue&type=style&index=0&id=3c09cb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c09cb16",
  null
  
)

export default component.exports